package features.members.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object BulkEditRoleModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "bulk-edit-role-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Bulk Edit Role" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("mb-6") {
                    p("text-slate-400 mb-4") {
                        id = "bulk-edit-count"
                        +"Change role for selected members"
                    }
                    
                    div {
                        label("block text-sm text-slate-400 mb-2") { +"New Role" }
                        select("w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "bulk-role-select"
                            option { value = "member"; +"Member" }
                            option { value = "admin"; +"Admin" }
                            option { value = "owner"; +"Owner" }
                        }
                    }
                    
                    div("mt-4 p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg") {
                        p("text-sm text-amber-400") {
                            +"⚠️ This will change the role for all selected members"
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition") {
                        onClickFunction = { js("applyBulkRoleEdit")() }
                        +"Apply to All"
                    }
                }
            }
        }
    }
}
